import React, { Fragment, useEffect, useRef } from "react";
import _ from "lodash";
import Image from "../Image";
import { preloadImages, isInViewport } from "../../Libs/utils";
import { Item } from "./item";
import { gsap } from "gsap";
import Lenis from "@studio-freight/lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import IntegrateImage from "../../Assets/Images/Websites/02_design.png";
import AutopilotImage from "../../Assets/Images/Websites/04_maintain.png";
import ReviewImage from "../../Assets/Images/Websites/03_develop.png";
import ExpandImage from "../../Assets/Images/Websites/05_scale.png";
import { Flip } from "gsap/Flip";
import "./index.scss";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);

export default function FeatureSpecial({ data, pageName }) {
  const contentElements = useRef([]);
  const totalContentElements = useRef(0);
  const lenisRef = useRef(false);

  const initSmoothScrolling = () => {/*
    const lenis = lenisRef.current
      ? lenisRef.current
      : new Lenis({
          lerp: 0.2,
          smoothWheel: true,
        });

    lenis.on("scroll", () => ScrollTrigger.update());

    const scrollFn = (time) => {
      lenis.raf(time);
      requestAnimationFrame(scrollFn);
    };
    requestAnimationFrame(scrollFn);*/
  };

  const scroll = () => {
    contentElements.current.forEach((el, position) => {
      const isLast = position === totalContentElements - 1;
      const scaleInitPoint = 1 - totalContentElements.current / 100;
      const scale = (position * 2) / 100 + scaleInitPoint;
      console.log("scaleval", scale);
      gsap
        .timeline({
          scrollTrigger: {
            trigger: el,
            start: "top top",
            end: "+=100%",
            scrub: true,
          },
        })
        .fromTo(
          el.querySelector(".content__img"),
          {
            opacity:0,
            yPercent: 10,
            rotation: 20,
          },
          {
            ease: "power1",
            yPercent: -60,
            rotation: -20,
            opacity:1,
            scrollTrigger: {
              trigger: el,
              start: "top bottom",
              end: "max",
              scrub: true,
            },
          },
          0
        )
        .to(
          el,
          {
            scaleX: isLast ? 1 : scale,
            scaleY: isLast ? 1 : scale,
          },
          {
            ease: "bounce.out",
            scaleX: isLast ? 1.05 : 1,
            scaleY: isLast ? 1.05 : 1,
            scrollTrigger: {
              trigger: el,
              start: "top top",
              end: "max",
              scrub: true,
            },
          },
          "start"
        );
    });
  };

  const init = () => {
    contentElements.current = [
      ...document.querySelectorAll(".content--sticky"),
    ];
    totalContentElements.current = contentElements.current.length;

    initSmoothScrolling();
    scroll();
  };

  useEffect(() => {
    preloadImages(".content__img").then(() => {
      init();
    });
  }, [data]);
  return null;
  return (
    <section className="bg-special js-section_nav-light">
      <div className="feature-special__content">
        <div className="content content--highlight content--intro">
          <h1 className="text-title">Go global with Lugath!</h1>
          <p className="text-large">
            As data conglomerates reveled in the opulence of cognitive wealth, a
            silent underclass manifested, condemned to the digital periphery.
          </p>
          <a className="text-link">Try Lugath Free</a>
        </div>
        <div className="wrap">
          <div
            style={{ "--offset": "0rem" }}
            className="content content--sticky content--grid bg-1"
          >
            <img
              className="content__img content__img--large content__img--left"
              src={ReviewImage}
            />
            <h2 className="content__title">
              Manual and automatic translation.
            </h2>
            <p className="content__text content__text--left text-meta">
              With Weglot, you don't have to start translation from scratch. You
              get a first layer of machine translation from the best machine
              translation tools (including DeepL) on the market. Then, use
              Weglot's post-editing features to make manual edits or work
              directly with professional translators.
            </p>
          </div>
          <div
            className="content content--sticky content--grid bg-1"
            style={{ "--offset": "2rem" }}
          >
            <img
              className="content__img content__img--large content__img--left"
              src={ExpandImage}
            />
            <h2 className="content__title">Optimized for multilingual SEO</h2>
            <p className="content__text content__text--left text-meta">
              Share your business with the world - quite literally. Weglot
              displays your website under language subdomains and
              subdirectories, making your site multilingual SEO-friendly. No
              more multiple websites or duplicate content!
            </p>
          </div>
          <div
            className="content content--sticky content--grid bg-1"
            style={{ "--offset": "4rem" }}
          >
            <img
              className="content__img content__img--large content__img--left"
              src="https://cdn.prod.website-files.com/60a6490e8523a3fd0c5dbd6e/60acbfb37ef92f97eca2ff8e_04-secure.png"
            />
            <h2 className="content__title">
              Secure and robust infrastructure.
            </h2>
            <p className="content__text content__text--left text-meta">
              Your translations and data are stored securely on Amazon Web
              Services' professional and secure servers within the EU.
            </p>
          </div>
          <div
            className="content content--sticky content--grid bg-1"
            style={{ "--offset": "6rem" }}
          >
            <img
              className="content__img content__img--large content__img--left"
              src="https://cdn.prod.website-files.com/60a6490e8523a3fd0c5dbd6e/60acbfb3d2909ce9954bf657_05-gdpr.png"
            />
            <h2 className="content__title">
              Data protection and GDPR compliant.
            </h2>
            <p className="content__text content__text--left text-meta">
              The translations stored on Weglot belong to you - you can do what
              you want with them. Weglot does not collect any personal data from
              website visitors and is therefore GDPR compliant.
            </p>
          </div>
          <div
            className="content content--sticky content--grid bg-1"
            style={{ "--offset": "8rem" }}
          >
            <img
              className="content__img content__img--large content__img--left"
              src={IntegrateImage}
            />
            <h2 className="content__title">Simple and fast integration.</h2>
            <p className="content__text content__text--left text-meta">
              Weglot integrates seamlessly with your website and adapts to your
              technology - no coding or extra developer time required. Just
              install Weglot, choose your translated language(s) and watch
              Weglot do the hard work for you. A multilingual website in
              minutes? It's that simple!
            </p>
          </div>
          <div className="content content--highlight content--outro">
          </div>
        </div>
        <div className="content content--highlight content--outro">
            <p className="text-large" style={{color:'#fff'}}>
              Lost in perpetual dependency, inhabitants of the Synthetic Era
              found solace in cryptic simulations, where pain ebbed and
              cognitive loads momentarily lightened.
            </p>
            <img
              className="content__img spacer"
              src="https://raw.githubusercontent.com/codrops/StickySections/refs/heads/main/img/2.png"
            />
          </div>
      </div>
    </section>
  );
}
